"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MaacComparisonParser = void 0;
var _ComparisonParser = require("../generic/ComparisonParser");
class MaacComparisonParser extends _ComparisonParser.ComparisonParser {
  productName(product) {
    return product.productName.split('+')[0];
  }
}
exports.MaacComparisonParser = MaacComparisonParser;